module.exports = __webpack_public_path__ + "static/media/locationHeader.816ec2c2.jpg";